import { z } from "zod";

import {
  ColorIconSchema,
  DetailsPopupInfoSchema,
  WorkTimeList,
} from "@shared/content-types/schemas/common.schema";
import { ArrayOfMediaSchema } from "@shared/content-types/schemas/media.schema";
import { TitleWithIconSchema } from "@shared/content-types/schemas/pageHero.schema";
import {
  FilterSchema,
  MetaSchema,
} from "@shared/content-types/schemas/pagination.schema";
import { SeoSchema } from "@shared/content-types/schemas/seo.schema";

export const EquipmentsPageSchema = z.object({
  id: z.number().int().positive(),
  documentId: z.string().min(1),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  publishedAt: z.string().datetime(),
  pageIcon: ColorIconSchema,
  titleWithIcon: TitleWithIconSchema,
  seo: SeoSchema.optional().nullable(),
});

export const EquipmentsPointSchema = z.object({
  id: z.number().int().positive(),
  documentId: z.string().min(1),
  title: z.string().min(1),
  uid: z.string().min(1),
  description: z.string().min(1),
  phone: z
    .string()
    .regex(/^\d \(\d{3}\) \d{3} \d{2} \d{2}$/, "Invalid phone format")
    .optional(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  publishedAt: z.string().datetime(),
  email: z.string().email(),
  location: z.string(),
  workTimeList: z.array(WorkTimeList.dynamic).optional(),
  photos: ArrayOfMediaSchema,
  equipments_types: z.array(FilterSchema).min(0),
  coordinates: z.string().optional(),
  detailInfo: z.array(DetailsPopupInfoSchema).optional(),
});

export const EquipmentsPageDtoSchema = z.object({
  data: EquipmentsPageSchema,
});

export const EquipmentsPointDtoSchema = z.object({
  data: z.array(EquipmentsPointSchema).min(0),
  meta: MetaSchema,
});

export const EquipmentTypesDtoSchema = z.object({
  data: z.array(FilterSchema).min(0),
  meta: MetaSchema,
});
